<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { DecisionSupportItem } from '../models';

const props = defineProps<DataTableCellProps<any, DecisionSupportItem>>();
const { item } = toRefs(props);

const parcels = computed(() => item.value.data.parcels.join(', '));
</script>

<template>
  <div>
    <span>
      <v-tooltip
        activator="parent"
        location="bottom"
        :text="parcels" />
      {{ parcels }}
    </span>
  </div>
</template>
